// @flow
import moment from './Moment'

export const DATE_VALID_FORMATS = [
  'Y-M-D', 'YYYY-M-D', 'YY-MM-D', 'YYYY-MM-D', 'YY-M-DD', 'YYYY-M-DD', 'YY-MM-DD', 'YYYY-MM-DD',
  'D.M.Y', 'D.M.YYYY', 'D.MM.YY', 'D.MM.YYYY', 'DD.M.YY', 'DD.M.YYYY', 'DD.MM.YY', 'DD.MM.YYYY',
]

export const checkDate = (dateString: string, domainMinDate: string, domainMaxDate: string) => {
  let date = moment(dateString, DATE_VALID_FORMATS, true)
  const minDate = domainMinDate
    ? moment(domainMinDate)
    : date.isValid()
      ? moment().set({ 'date': date.date(), 'month': date.month(), year: moment().year() - 99 })
      : moment().add(-99, 'years')
  date = date.isValid() ? moment.max(minDate, date) : minDate
  if (domainMaxDate) {
    const maxDate = moment(domainMaxDate)
    date = date.isValid() ? moment.min(maxDate, date) : maxDate
  }
  return date
}

export const renderDate = (dateString: string, editCompleted: boolean) => {
  const date = moment(dateString, DATE_VALID_FORMATS, true)
  if (!dateString || !date.isValid() || !editCompleted) {
    return dateString
  }
  return date.format('DD.MM.YYYY')
}

export const parseRelativeDatetime = (relativeDatetime: string) => {
  const add = relativeDatetime.indexOf('-') === 0 ? -1 : 1
  const numberArray = relativeDatetime.match(/\d+/)
  const unitsArray = relativeDatetime.match(/(\D+)$/)
  const supportedUnits = {
    d: 'd',
    m: 'M',
    y: 'Y'
  }
  const unit = Array.isArray(unitsArray) ? supportedUnits[unitsArray[0]] || 'd' : 'd'
  return moment().add(Array.isArray(numberArray) ? numberArray[0] * add : 0, unit)
}

export const relativeToDate = (dateTimeRelative: string, dateNum: number, cutoff: number) => {
  let pos = 1
  if (typeof cutoff === 'undefined' || !cutoff) {
    cutoff = 1
  } else if (cutoff) {
    cutoff = 0
  }
  let date = new Date(dateNum)
  if (dateTimeRelative[0] === '+') {
    pos = 1
    dateTimeRelative = dateTimeRelative.substr(1)
  } else if (dateTimeRelative[0] === '-') {
    pos = -1
    dateTimeRelative = dateTimeRelative.substr(1)
  }
  const regex = dateTimeRelative.match("(([0-9]+)d)?(([0-9]+)m)?(([0-9]+)y)?")
  let days = 0
  let months = 0
  let years = 0
  if (typeof regex[2] !== 'undefined') {
    days = parseInt(regex[2], 10)
  }
  if (typeof regex[4] !== 'undefined') {
    months = parseInt(regex[4], 10)
  }
  if (typeof regex[6] !== 'undefined') {
    years = parseInt(regex[6], 10)
  }
  return moment(Date.UTC(date.getUTCFullYear() + (pos * years), date.getUTCMonth() + (pos * months), date.getUTCDate() + (pos * days),
    date.getUTCHours() * cutoff, date.getUTCMinutes() * cutoff, date.getUTCSeconds() * cutoff, date.getUTCMilliseconds() * cutoff))
}

export default {
  DATE_VALID_FORMATS,
  checkDate,
  renderDate,
  parseRelativeDatetime,
}
